webpackJsonp([5],{

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(322),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(72);

var _com = __webpack_require__(9);

__webpack_require__(311);

var _config = __webpack_require__(28);

var _elementUi = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyCont = function emptyCont() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 289));
};
var contentList = function contentList() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 288));
};

exports.default = {
  data: function data() {
    return {
      filters: {
        category: ''
      },
      newloading: false,
      show: true,
      page: 1,
      limit: 10,
      clientid: 1,
      linkpath: './review'
    };
  },
  created: function created() {
    console.debug("created> page:%o", this.$route.query.page);
    var curpage = this.$route.query.page || 1;
    this.page = parseInt(curpage);
    this.filters.category = this.$route.query.category || '';
    this.reqNewsListData();
  },
  mounted: function mounted() {
    console.debug("mounted");
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch>route page:%o", this.$route.query.page);
      var curpage = this.$route.query.page || 1;
      this.page = parseInt(curpage);
      this.filters.category = this.$route.query.category || '';
      this.reqNewsListData();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    pressdata: 'pressdata',
    presstotal: 'presstotal',
    getRole: 'getRole',
    getAccesstoken: 'getAccesstoken',
    getAppid: 'getAppid'
  }), {
    getPressDataLen: function getPressDataLen() {
      console.debug("getPressDataLen> pressdata.length:%o", this.pressdata.length);
      return this.pressdata.length;
    },
    formatCategory: function formatCategory() {
      var typelists = [];
      for (var i in _config.newsType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.newsType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    formatNewsData: function formatNewsData() {
      var lists = [];
      console.debug("formatNewsData> pressdata:%o", this.pressdata);
      for (var i in this.pressdata) {
        var l = {};
        var newdata = this.pressdata[i];


        l = (0, _com.cloneObj)(newdata);
        var hi = newdata.hotindex + '' || '7';
        l.hotindex = _config.hotsType[hi];

        var cat = newdata.category || '1';
        l.category = _config.newsType[cat];
        var ls = newdata.labels || '#';
        l.labels = ls.split('#');

        l.labels = ls.split('#');
        lists.push(l);
      }
      console.debug("formatMarkers> lists:%o", lists);
      return lists;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    getPressData: 'getPressData',
    updateNewsContent: 'updateNewsContent',
    updateLoadingStatus: 'updateLoadingStatus',
    outLogin: 'outLogin'
  }), {
    reqNewsListData: function reqNewsListData() {
      var _this = this;

      var that = this;
      var param = {
        appid: that.getAppid,
        accesstoken: that.getAccesstoken,
        clientid: that.clientid,
        category: that.filters.category,
        page: that.page,
        limit: that.limit
      };
      console.debug("reqNewsListData> param:%o", param);
      that.updateLoadingStatus(true);
      that.getPressData(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("reqNewsListData> getPressData> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
          setTimeout(function () {
            that.outLogin();
            _this.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: 'press' } });
          }, 3000);
        }
      });
    },
    handlePageChange: function handlePageChange(val) {
      console.debug("handlePageChange> val:%o", val);
      if (this.page !== val) {
        this.page = val;
      }
      this.$router.push({ path: (0, _com.routeMap)('/press/list'), query: { page: this.page, category: this.filters.category } });
    },
    handleCategoryChange: function handleCategoryChange(val) {
      console.debug("handleCategoryChange> val:%o, category:%o", val, this.filters.category);

      this.$router.push({ path: (0, _com.routeMap)('/press/list'), query: { page: this.page, category: this.filters.category } });
    },
    goReview: function goReview(item) {
      if (!item) {
        return false;
      }
      item.labels = item.labels.join('#');
      for (var i in _config.newsType) {
        if (_config.newsType[i] === item.category) {
          item.category = i;
          break;
        }
      }

      for (var _i in _config.hotsType) {
        if (_config.hotsType[_i] === item.hotindex) {
          item.hotindex = _i;
          break;
        }
      }
      console.debug("goto> item:%o", item);
      this.updateNewsContent(item);
      this.$router.push({ path: './review', query: { id: item.id } });
    }
  }),
  components: {
    emptyCont: emptyCont,
    contentList: contentList
  }
};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(273)();
// imports


// module
exports.push([module.i, "#presslist .el-item.item-2x{padding:20px;box-sizing:border-box;min-height:195px}#presslist .el-form-item{margin-bottom:0}#presslist .el-tag{padding:0 12px}#presslist .el-progress-bar__outer{border-radius:4px}#presslist .el-progress-bar__inner{border-radius:0}#presslist .el-progress.is-success .el-progress-bar__inner{background:#b9d963}#presslist .el-pagination{margin-top:0;padding:.8rem}#presslist .month-turnover{padding:10px 15px;border-radius:5px;margin-top:28px}#presslist .head-form,#presslist .nav-pagin{padding:.5rem 0}#presslist .news-box{padding:10px 15px;display:flex;flex-direction:column;justify-content:flex-start}#presslist .news-box .box-header{width:100%;display:inline-flex;flex-direction:row;justify-content:space-between}#presslist .news-box .box-header .new-type{color:#58b7ff;font-weight:700}#presslist .news-box .box-header .hot-level{color:#d22953;font-weight:700}#presslist .news-box .box-title{margin:10px 0}#presslist .news-box .box-content{display:inline-flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;margin:5px 0}#presslist .news-box .box-content .box-image{width:20%;margin-right:14px}#presslist .news-box .box-content .box-text{color:#99a9bf;overflow:hidden;display:-webkit-box;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:3}#presslist .news-box .box-foot{width:100%;display:inline-flex;flex-direction:row;justify-content:flex-end;color:#99a9bf;font-size:8px}#presslist .loading-box{position:fixed;left:40%;top:40%}#presslist .loading-box .transition-box{margin-bottom:10px;width:200px;height:100px;border-radius:4px;background-color:#20a0ff;text-align:center;color:#fff;padding:40px 20px;box-sizing:border-box;margin-right:20px}", "", {"version":3,"sources":["D:/project/Temp/src/static/style/press/D:\\project\\Temp/src\\static\\style\\press\\list.scss"],"names":[],"mappings":"AAAA,4BAEQ,aAAa,AACb,sBAAsB,AACtB,gBAAiB,CACpB,AALL,yBAUQ,eAAgB,CACnB,AAXL,mBAaQ,cAAe,CAClB,AAdL,mCAgBQ,iBAAkB,CACrB,AAjBL,mCAmBQ,eAAgB,CACnB,AApBL,2DAsBQ,kBAAmB,CACtB,AAvBL,0BAyBQ,aAAa,AACb,aAAc,CACjB,AA3BL,2BA6BQ,kBAAkB,AAClB,kBAAkB,AAClB,eAAgB,CACnB,AAhCL,4CAqCQ,eAAgB,CACnB,AAtCL,qBAyCQ,kBAAkB,AAElB,aAAa,AACb,sBAAsB,AACtB,0BAA2B,CAiD9B,AA9FL,iCAgDY,WAAW,AACX,oBAAoB,AACpB,mBAAmB,AACnB,6BAA8B,CAUjC,AA7DT,2CAqDgB,cAAc,AACd,eAAiB,CACpB,AAvDb,4CAyDgB,cAAc,AACd,eAAiB,CACpB,AA3Db,gCA+DY,aAAc,CACjB,AAhET,kCAkEU,oBAAoB,AACpB,mBAAmB,AACnB,2BAA2B,AAC3B,uBAAuB,AACvB,YAAa,CAcd,AApFT,6CAwEY,UAAU,AACV,iBAAkB,CACnB,AA1EX,4CA4EgB,cAAc,AACd,gBAAgB,AAChB,oBAAoB,AACpB,uBAAuB,AACvB,4BAA4B,AAC5B,oBAAqB,CAE1B,AAnFX,+BAsFY,WAAW,AACX,oBAAoB,AACpB,mBAAmB,AACnB,yBAAyB,AACrB,cAAc,AAClB,aAAc,CAEjB,AA7FT,wBAiGQ,eAAc,AACd,SAAQ,AACR,OAAO,CAaV,AAhHL,wCAqGY,mBAAmB,AACnB,YAAY,AACZ,aAAa,AACb,kBAAkB,AAClB,yBAAyB,AACzB,kBAAkB,AAClB,WAAW,AACX,kBAAkB,AAClB,sBAAsB,AACtB,iBAAkB,CACrB","file":"list.scss","sourcesContent":["#presslist {\r\n    .el-item.item-2x {\r\n        padding: 20px;\r\n        box-sizing: border-box;\r\n        min-height: 195px;\r\n    }\r\n    .el-row {\r\n        /*margin-bottom: 15px;*/\r\n    }\r\n    .el-form-item {\r\n        margin-bottom: 0;\r\n    }\r\n    .el-tag {\r\n        padding: 0 12px;\r\n    }\r\n    .el-progress-bar__outer {\r\n        border-radius: 4px;\r\n    }\r\n    .el-progress-bar__inner {\r\n        border-radius: 0;\r\n    }\r\n    .el-progress.is-success .el-progress-bar__inner {\r\n        background: #B9D963;\r\n    }\r\n    .el-pagination {\r\n        margin-top: 0;\r\n        padding: .8rem;\r\n    }\r\n    .month-turnover {\r\n        padding: 10px 15px;\r\n        border-radius: 5px;\r\n        margin-top: 28px;\r\n    }\r\n    .head-form{\r\n        padding: .5rem 0;\r\n    }\r\n    .nav-pagin{\r\n        padding: .5rem 0;\r\n    }\r\n\r\n    .news-box{\r\n        padding: 10px 15px;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n\r\n        .box-header{\r\n            width: 100%;\r\n            display: inline-flex;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            .new-type{\r\n                color: #58B7FF;\r\n                font-weight: bold;\r\n            }\r\n            .hot-level{\r\n                color: #d22953;\r\n                font-weight: bold;\r\n            }\r\n\r\n        }\r\n        .box-title{\r\n            margin: 10px 0;\r\n        }\r\n        .box-content{\r\n          display: inline-flex;\r\n          flex-direction: row;\r\n          justify-content: flex-start;\r\n          align-items: flex-start;\r\n          margin: 5px 0;\r\n          .box-image{\r\n            width: 20%;\r\n            margin-right: 14px;\r\n          }\r\n          .box-text{\r\n                color: #99A9BF;\r\n                overflow: hidden;\r\n                display: -webkit-box;\r\n                text-overflow: ellipsis;\r\n                -webkit-box-orient: vertical;\r\n                -webkit-line-clamp: 3;\r\n                /*height: 20px;*/\r\n          }\r\n        }\r\n        .box-foot{\r\n            width: 100%;\r\n            display: inline-flex;\r\n            flex-direction: row;\r\n            justify-content: flex-end;\r\n                color: #99A9BF;\r\n            font-size: 8px;\r\n\r\n        }\r\n    }\r\n\r\n    .loading-box{\r\n        position:fixed;\r\n        left:40%;\r\n        top:40%;\r\n        .transition-box {\r\n            margin-bottom: 10px;\r\n            width: 200px;\r\n            height: 100px;\r\n            border-radius: 4px;\r\n            background-color: #20A0FF;\r\n            text-align: center;\r\n            color: #fff;\r\n            padding: 40px 20px;\r\n            box-sizing: border-box;\r\n            margin-right: 20px;\r\n        }\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(303);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(274)("33da7770", content, true);

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "presslist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getPressDataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "goUrl": _vm.goReview,
      "limit": _vm.limit,
      "total": _vm.presstotal,
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 21,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.presstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.e7cd8bbfad325743be7b.js